import "./Register.css";
import email_icon from "../../Assets/email.png";
import password_icon from "../../Assets/password.png";
import person_icon from "../../Assets/person.png";
import contact_icon from "../../Assets/contact.png";
import { registerAsync } from "../../api/AccountApi";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ResponseMessage } from "../../models/ResponseMessage";

const Register: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [contact, setContact] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleRegister = async () => {
    if (!name || !email || !password || !confirmPassword) {
      alert("Please fill all the fields");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const response: ResponseMessage<string> = await registerAsync(
        email,
        password,
        name,
        contact
      );

      if (response.success) {
        setLoading(false);
        navigate("/register-complete", { state: { email } });
      } else {
        setLoading(false);
        console.log("response", response);
      }
    } catch (error) {
      setLoading(false);
      console.error("❌ Registration failed:", error);
      alert("Registration failed. Please try again.");
    }
  };

  return (
    <div className="container">
      <div className="holder_register">
        <div className="inputs">
          {loading && (
            <div className="loading-overlay">
              <div className="spinner"></div>
            </div>
          )}
          <label className="name">Sign Up</label>
          <div className="input-wrapper">
            <img className="input-icon" src={person_icon} alt="person icon" />
            <input
              className="input"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="input-wrapper">
            <img className="input-icon" src={email_icon} alt="email icon" />
            <input
              className="input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="input-wrapper">
            <img className="input-icon" src={contact_icon} alt="contact icon" />
            <input
              className="input"
              placeholder="Contact No"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </div>

          <div className="input-wrapper">
            <img
              className="input-icon"
              src={password_icon}
              alt="password icon"
            />
            <input
              className="input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="input-wrapper">
            <img
              className="input-icon"
              src={password_icon}
              alt="password icon"
            />
            <input
              className="input"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button className="register-btn" onClick={handleRegister}>
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;
